import React, { Component } from "react";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";

export class DetailsInfo extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
        }
    }
    render(){
        return(
            <div className={this.props.customClass}>
                <SelectField label="ACCOUNT TYPE"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                <InputField label="ACCOUNT NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="SUB-ACCOUNT NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <SelectField label="CONTRACT NAME"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                <InputField label="VENDOR" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <SelectField label="CURRENCY"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                <InputField label="SERVICE TYPE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <SelectField label="ACCOUNT STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                <InputField label="INVOICE FORMAT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="DESCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <DATEPICKER_OR label="TAKE-OVER DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                <DATEPICKER_OR label="PO VALID DUE DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                <DATEPICKER_OR label="EXPECTED INVOICE RECEIPT DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                <InputField label="PO NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="PO VALUE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="CLIENT NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="FIRST BILL REVIEW" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <SelectField label="INVOICE INTERNAL"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                <SelectField label="ALLOCATION LEVEL"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                <InputField label="COMMENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <TabberButton label="AP in-scope"/>
                <InputField label="REQUESTER NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <InputField label="REMIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <div></div>
                <SelectField label="AP VENDOR ID"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
            </div>
        )
    }
}